import React from "react";

export const FormManagerContext = React.createContext({
    isReadOnly:false,
    isProcess:false,
});